import { Injectable } from '@angular/core';
import { SESSION_TYPE, SessionService } from './session.service';
import {
     IInternalClientInfo,
     ILoginObRes,
     ILoginRes,
     ISession,
} from '../../typings';
import { WsService } from './ws/ws.service';

@Injectable()
export class SessionPrepareService {
     constructor(private session: SessionService, private ws: WsService) {}

     async run(external: boolean, res1: ILoginObRes, res2: ILoginRes) {
          let internalClientInfo: IInternalClientInfo;
          let session: ISession;
          if (external) {
               session = {
                    firstName: res1.firstName,
                    idSession: res1.id,
                    lastName: res1.lastName,
                    idClient: res1.idClient,
                    idClientOb: null,
                    idClubOb: res1.idClubOb,
                    email: res1.email,
                    idClub: res1.idClub,
                    initialQuestionAnswered: false,
                    balanceError: res1.balanceError,
                    photo: res1.photo,
               };
               this.session.set(session, SESSION_TYPE.EXTERNAL);
          } else {
               session = { idSession: res2.token } as any; // Set the token temporarily for the next call
               this.session.set(session, SESSION_TYPE.INTERNAL);
               internalClientInfo = await this.ws.internalClient.me();
               session = {
                    firstName: internalClientInfo.firstName,
                    idSession: res2.token,
                    lastName: internalClientInfo.lastName,
                    idClient: internalClientInfo.id,
                    idClientOb: null,
                    idClubOb: window.app.club.obId,
                    email: null,
                    idClub: window.app.club.id,
                    initialQuestionAnswered: false,
                    balanceError: false,
                    photo: internalClientInfo.photo,
               };
               this.session.set(session, SESSION_TYPE.INTERNAL);
          }
          return session;
     }
}
